export default __webpack_public_path__ + "static/media/carousel-item-06.d2ee1419.png";